// extracted by mini-css-extract-plugin
module.exports = {"tickerMessage":"TickerStatusMessage_tickerMessage__A8272"};